export enum PageType {
    Home = "Home",
    Step1 = "Step 1 - Specification",
    Step2 = "Step 2 - Implementation",
    Step3 = "Step 3 - Verification",
    Search = "Search",
    Elements = "Elements",
    Download = "Download",
    Master = "Master",
    Content = "Content",
}
